import { useClient } from '@adamlip/okeoke.client';
import { AppParamsContext } from 'contexts/AppParamsContext';
import { useContext, useEffect, useRef } from 'react';
import { Link, scrollSpy } from 'react-scroll';

function CategoryElement({
  categoryUUID,
  categories,
  selectedCategory,
  setSelectedCategory,
  addRefToArray,
  scrollToElement,
  isMainCategory = false,
  activeMainCategory,
  setActiveMainCategory,
}) {
  const { getName } = useClient();
  const { appParams } = useContext(AppParamsContext);
  const ref = useRef(null);
  const ref2 = useRef(null);

  useEffect(() => {
    if (ref.current != null && typeof addRefToArray === 'function') addRefToArray(ref);
    scrollSpy.update();
    //eslint-disable-next-line
  }, []);

  const handleClickOnCategory = (uuid) => {
    if (typeof setSelectedCategory === 'function') setSelectedCategory(uuid);
  };

  const handleSetActive = (to) => {
    console.log('to', to);

    if (typeof scrollToElement === 'function') scrollToElement(to);
  };
  const handleSetActiveMainCategory = (to) => {
    if (!isMainCategory) return;
    if (typeof setActiveMainCategory === 'function') setActiveMainCategory(to);
  };
  return (
    <div className='h-full flex items-center justify-center '>
      <div
        className={`border-none mr-[0.5em] overflow-hidden  flex items-center justify-center text-xs h-[2rem] text-center w-max  font-bold uppercase `}
        id={`categList_${categoryUUID}`}
        ref={ref}>
        <Link
          activeClass='border-b-2 border-b-[var(--selectedCategory-BgColor)]  text-[var(--selectedCategory-TextColor)] transition-colors'
          to={`orderItemList-byCategory_${categoryUUID}`}
          containerId='orderItemList-byCategory'
          onClick={() => handleClickOnCategory(categoryUUID)}
          className={`h-full border-b-2 border-b-transparent px-2 flex items-center justify-center cursor-pointer transition-colors ${activeMainCategory === categoryUUID ? 'border-b-2 border-b-[var(--selectedCategory-BgColor)]  text-[var(--selectedCategory-TextColor)] transition-colors' : ''
            }`}
          smooth={true}
          duration={500}
          spy={true}
          onSetActive={(to) => {
            handleSetActive(to);
            handleSetActiveMainCategory(categoryUUID);
          }}>
          <div ref={ref2} style={{ width: '100%', height: '100%' }} className='flex items-center justify-center'>
            <div className={`orderItemCategory-name ${appParams?.styles?.fonts?.capitalize ? 'font-extrabold uppercase' : ''}`}>{getName(categories?.[categoryUUID]?.name)}</div>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default CategoryElement;
